<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between p-4">
        <div class="flex z-50 items-center">
          <RandomText class="text-3xl">Broomx Interface</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1"
            >Web Developer</RandomText
          >
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "Durant les meves pràctiques a Broomx, vaig treballar en el desenvolupament de la plataforma web que permet planificar i enviar informació directament als projectors. En aquestes, vaig tenir l'oportunitat de col·laborar estretament amb un equip multidisciplinari. Vaig treballar directament amb un altre desenvolupador de front-end, compartint responsabilitats en la creació de la interfície. També vaig col·laborar amb el desenvolupador de back-end i la dissenyadora gràfica, assegurant que hi hagués una comunicació fluida i una excel·lent organització d'equip.",
        },
        {
          type: "image",
          content: "/img/broomx/broomx1.png",
        },
        {
          type: "image",
          content: "/img/broomx/broomx2.png",
        },
        {
          type: "image",
          content: "/img/broomx/broomx.png",
        },
        {
          type: "image",
          content: "/img/broomx/broomx3.png",
        },
        {
          type: "image",
          content: "/img/broomx/broomx4.png",
        },
      ],
      process: [
        {
          text: "Aquesta web està construïda amb Svelte i estilitzada amb Tailwind CSS. Gran part de la meva tasca va consistir a ajudar en la maquetació de la web, assegurant que fos funcional, responsive i estèticament coherent amb el disseny establert. També vaig participar en la integració de components i millores d'usabilitat, assegurant una experiència fluida tant per a usuaris interns com externs.",
        },
      ],
      processInfo: [
        {
          title: "Client:",
          subtitle: "Museum of Ethnography Neuchâtel (MEN)",
        },
        {
          title: "Location:",
          subtitle: "Museum’s Gardens (MEN)",
        },
        {
          title: "Direction:",
          subtitle: "Grégoire Mayor and Yann Laville",
        },
        {
          title: "Scenography:",
          subtitle:
            "Curious Space - Anna Jones, Raphaël von Allmen, Elfyn Round",
        },
        {
          title: "Photography:",
          subtitle: "Prune Simon-Vermot, Grégoire Mayor",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>